import { useContext } from "react"
import MoveLawActsContext from "../context/MoveLawActsContext"

const useMoveLawActs = () => {
    return useContext(MoveLawActsContext);
}

export default useMoveLawActs